import { useState } from 'react';
import { useSelector } from 'react-redux';
import { Button, Typography, Box } from '@mui/material';
import { modernLinkRedirect } from '../../common/services/proxyServices';
import ForwardLink from '../../components/common/ForwardLink/ForwardLink'
import { policyNumberValidation } from '../../common/utilities/CustomValidatorUtil';
import '../../common/theme/CommonStyles.scss';
import './QuickSearch.scss';
import constants from '../../constants';

const QuickSearchComponent = ({user}) => {  
  const selectedProfile = useSelector(state => state.selectedProfile);
  let [policyNumber, setPolicyNumber] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [blurredOnce, setBlurredOnce] = useState(false);

  const advancedSearchNavigate = async (gpa, pc, action) => {
    if(action === 'adv') {
      policyNumber = ' ';
    }
    const url = await modernLinkRedirect(user, policyNumber, gpa, pc);
    if(gpa || pc) {
      return url;
    }
    window.open(url, '_self');
    return null;
  }

  const handleInputChange = (event) => {
    const inputValue = event.target.value;
    setPolicyNumber(inputValue);
    const validationErrorMessage = policyNumberValidation(inputValue);
    setErrorMessage(blurredOnce? validationErrorMessage: '');
    setIsButtonDisabled(!!validationErrorMessage || inputValue === '');
  };

  const handleBlur = () => {
    const policyValue = policyNumber.replace(/-/g, '').trim()
    setPolicyNumber(policyValue);
    const validationErrorMessage = policyNumberValidation(policyValue);
    setErrorMessage(validationErrorMessage);
    if(policyValue === '') {
      setBlurredOnce(false);
    } else {
      setBlurredOnce(true);
    }
    setIsButtonDisabled(!!validationErrorMessage || policyValue === '');
  };

  const handleKeyDown = (event) => {
      const isNavigationOrFunctionalKey = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Escape', 'Enter', 'Tab'].includes(event.key);
      const isMacCommandAllowed = event.metaKey && (event.key === 'c' || event.key === 'v' || event.key === 'x' || event.key === 'a');
      const isControlCommandAllowed = event.ctrlKey && (event.key === 'c' || event.key === 'v' || event.key === 'x' || event.key === 'a');

      if (!isNavigationOrFunctionalKey && !isMacCommandAllowed && !isControlCommandAllowed) {
          // Regular expression to allow digits and hyphens only
          const allowedCharacters = /^[0-9-]+$/;

          if (!allowedCharacters.test(event.key)) {
              event.preventDefault();
          }
          
          if (policyNumber.length >= 10 && allowedCharacters.test(event.key)) {
              event.preventDefault();
              setErrorMessage('Please enter a valid quote or policy number.');
          }
      }
  };

  const handleNavigate = async () => {
    if (user) {
      const newURL = selectedProfile?.amsuitePreference?.toLowerCase() !== constants.amsuite ? await advancedSearchNavigate(false, true) : await advancedSearchNavigate(true, false);
      return newURL;
    }
    return '';
  };

  return (
    <Box className='quickSearch'>
      <Box className='quickSearchCard'>
        <Typography variant='h3' className='quickSearch-title'>Quick search</Typography>
        <form name="input" action={''} method="post" target="_self" 
         onSubmit={async (e) => {
          e.preventDefault();
          const newURL = await handleNavigate(user);
          if (newURL) {
            window.open(newURL, '_self');
          } 
         }}
        >
        <Box className='quickSearch-field'>
            <label
              htmlFor='agentnumber'
              className='quickSearch-label'>
              Quote or policy number
            </label>
            <input
              id='quickSearchInput'
              className={`quickSearch-field inputBox ${errorMessage ? 'inputError' : ''}`}
              value={policyNumber}
              onChange={handleInputChange}
              onBlur={handleBlur}
              onKeyDown={handleKeyDown}
            />
            {errorMessage && <div className='error-message'>{errorMessage}</div>}
          </Box>
          <Box className='buttonsBox'>
            <Box className='continueButton'>
              <Button className='quick-search-continue-button' disabled={isButtonDisabled} type="submit" value="Submit"> Search </Button>
            </Box>
            <ForwardLink url='/advanced-search' text='Or advanced search' sameTab='true'></ForwardLink>       
          </Box>
        </form>
      </Box>
    </Box>
  );
}

export default QuickSearchComponent;